import { useState } from 'react';

export type ProjectTabType = 'overview' | 'files' | 'audit-trail' | 'timesheet';

interface Tab {
    id: ProjectTabType;
    label: string;
    icon: string;
}

interface ProjectTabsProps {
    activeTab: ProjectTabType;
    onTabChange: (tab: ProjectTabType) => void;
}

const tabs: Tab[] = [
    { id: 'overview', label: 'Overview', icon: '/svg/overview.svg' },
    // { id: 'files', label: 'Files', icon: '/svg/storage.svg' },
    // { id: 'audit-trail', label: 'Audit Trail', icon: '/svg/audit.svg' },
    // { id: 'timesheet', label: 'Timesheet', icon: '/svg/timesheet.svg' },
];

export const ProjectTabs = ({ activeTab, onTabChange }: ProjectTabsProps) => {
    return (
        <div className="project-tabs">
            <div className="project-tabs__container">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`project-tabs__tab ${activeTab === tab.id ? 'project-tabs__tab--active' : ''}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        <img src={tab.icon} alt={tab.label} className="project-tabs__icon" />
                        <span className="project-tabs__label">{tab.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
